import React from 'react';
import { Section } from '../ui/Section';
import { PieChart, TrendingUp } from 'lucide-react';
export function MegapackDetails() {
  return <Section className="bg-teal-900 text-white" data-id="element-140">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-141">
        <div className="text-center mb-8 md:mb-12" data-id="element-142">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" data-id="element-143">
            ¿QUÉ AGREGA EL MEGAPACK COMPLETO?
          </h2>
          <p className="text-teal-200 text-base md:text-lg" data-id="element-144">
            Para oncólogos que quieren ir un paso más allá en la gestión de su
            consultorio
          </p>
        </div>

        <div className="bg-teal-950 rounded-2xl md:rounded-3xl p-5 md:p-8 border border-teal-800 mb-8 md:mb-12 hover:border-teal-700 transition-colors" data-id="element-145">
          <h3 className="text-lg md:text-xl font-bold text-center mb-5 md:mb-8 border-b border-teal-800 pb-3 md:pb-4" data-id="element-146">
            Facturación desordenada y sin visibilidad financiera
          </h3>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-147">
            <div className="relative" data-id="element-148">
              <div className="text-red-400 font-bold mb-1 md:mb-2 uppercase text-xs md:text-sm tracking-wider" data-id="element-149">
                Sin Megapack
              </div>
              <p className="text-sm md:text-base text-teal-100" data-id="element-150">
                Facturás cada mes pero no sabés con certeza cuánto rinde tu
                consultorio ni cuánto te deben.
              </p>
            </div>
            <div className="relative" data-id="element-151">
              <div className="hidden md:block absolute -left-4 top-0 bottom-0 w-px bg-teal-800" data-id="element-152"></div>
              <div className="text-amber-400 font-bold mb-1 md:mb-2 uppercase text-xs md:text-sm tracking-wider" data-id="element-153">
                Con Megapack
              </div>
              <p className="text-sm md:text-base text-white font-medium" data-id="element-154">
                Tablero financiero mensual y dashboard de indicadores para tomar
                decisiones con datos reales, no con sensación.
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-155">
          <div className="bg-teal-800/50 p-5 md:p-6 rounded-2xl border border-teal-700 hover:bg-teal-800/70 transition-colors group" data-id="element-156">
            <PieChart className="h-8 w-8 md:h-10 md:w-10 text-amber-400 mb-3 md:mb-4 group-hover:scale-110 transition-transform" data-id="element-157" />
            <h4 className="text-lg md:text-xl font-bold mb-1 md:mb-2" data-id="element-158">
              T7 — Facturación y Gestión Financiera
            </h4>
            <p className="text-sm md:text-base text-teal-100" data-id="element-159">
              Control de cobros, días de cobro promedio y punto de equilibrio
              del consultorio.
            </p>
          </div>
          <div className="bg-teal-800/50 p-5 md:p-6 rounded-2xl border border-teal-700 hover:bg-teal-800/70 transition-colors group" data-id="element-160">
            <TrendingUp className="h-8 w-8 md:h-10 md:w-10 text-amber-400 mb-3 md:mb-4 group-hover:scale-110 transition-transform" data-id="element-161" />
            <h4 className="text-lg md:text-xl font-bold mb-1 md:mb-2" data-id="element-162">
              T8 — Tablero de Indicadores
            </h4>
            <p className="text-sm md:text-base text-teal-100" data-id="element-163">
              Los 6 indicadores clave de tu consultorio, integrados en una sola
              vista mensual.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}